import { BlockCard } from "src/modules/worksheet/components/WorksheetEditor/components/Editor";

const renderCardPhone = (props: any) => {
    return <BlockCard {...props}>Phone Number Block</BlockCard>;
};

export default renderCardPhone;
